import {
  requiredRule,
  useFormControl,
  type FormControlProps,
} from "@mongez/react-form";
import { cn } from "core/shared";
import { useEffect, type ReactNode } from "react";
import { Switch } from "../ui/switch";
import { ErrorInput } from "./ErrorInput";
import { LabelInput } from "./LabelInput";

type SwitchInputProps = FormControlProps & {
  label?: ReactNode;
  collectUnchecked?: boolean;
  uncheckedValue?: any;
  defaultValue?: any;
  checked?: boolean;
  classes?: {
    wrapper?: string;
    label?: string;
    input?: string;
    error?: string;
  };
};

export function SwitchInput({
  label,
  collectUnchecked = false,
  uncheckedValue = false,
  classes,
  ...props
}: SwitchInputProps) {
  const { checked, setChecked, id, error, disabled, otherProps } =
    useFormControl(
      {
        rules: [requiredRule],
        type: "checkbox",
        ...props,
      },
      // {
      //   collectUnchecked,
      //   isCollectable(formControl) {
      //     return formControl.checked;
      //   },
      //   uncheckedValue,
      //   collectValue() {
      //     return defaultValue;
      //   },
      // },
    );

  useEffect(() => {
    if (props.defaultValue !== undefined && props.defaultValue !== checked) {
      setChecked(props.defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.defaultValue]);

  const handleChange = (checked: boolean) => {
    setChecked(checked);
  };

  return (
    <>
      <div className={cn("flex items-center gap-2", classes?.wrapper)}>
        <Switch
          {...otherProps}
          id={id}
          aria-disabled={disabled}
          disabled={disabled}
          checked={checked}
          defaultChecked={props.defaultChecked}
          onCheckedChange={handleChange}
          className={classes?.input}
        />
        <LabelInput
          className={cn("mb-0", classes?.label)}
          htmlFor={id}
          required={props.required}
        >
          {label}
        </LabelInput>
      </div>
      <ErrorInput className={classes?.error}>{error}</ErrorInput>
    </>
  );
}
